<template>
  <v-snackbar-queue
    v-model="store.queue"
    class="print:hidden"
    location="bottom"
    :width="344"
    :gap="12"
    :total-visible="5"
    rounded="lg"
    display-strategy="overflow"
    :style="{ zIndex: snackbarZIndex }"
  >
    <template #text="{ item }">
      <UISnackbarSnack :variant="item.type">
        {{ $t(item.text || '') }}
        <a
          v-if="item.link"
          :href="item.link.href"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary underline"
        >
          {{ $t(item.link.label) }}
        </a>
      </UISnackbarSnack>
    </template>
    <template #actions="{ item, props: actionProps }">
      <UIIconButton
        v-if="item.showClose"
        icon="mdi-close"
        variant="black"
        @click="actionProps.onClick"
      />
    </template>
  </v-snackbar-queue>
</template>

<script lang="ts" setup>
import { snackbarZIndex } from '@manager/config/constants';
import UISnackbarSnack from '@manager/modules/snackbar/components/UISnackbarSnack.vue';
import { useSnackbarStore } from '@manager/modules/snackbar/snackbar-store';
import UIIconButton from 'shared/ui/registry/kinnovis/ui-icon-button/UIIconButton.vue';

const store = useSnackbarStore();
</script>

<style lang="scss">
.v-snackbar__content.app-snackbar {
  padding: 12px 12px 12px 16px;
  box-shadow: 0 6px 16px rgb(0 0 0 / 0.08);
}

// Center snackbar to the viewport, ignoring Vuetify layout offsets (drawer/app-bar)
.v-snackbar {
  padding-inline: 0 !important;
  padding-bottom: 12px !important;
}
</style>
